import Vue from 'vue';
import VueRouter from 'vue-router';
import viewRoot from '@/views/root';

Vue.use(VueRouter);

//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  {
    path: '/',
    redirect: '/homeView',
    component: viewRoot,
    children: [
      {
        path: 'homeView',
        name: 'HomeView',
        component: () =>
          import(/* webpackChunkName: "cityCompany" */ '@/views/root/homeView'),
      },
      {
        path: 'cityCompany',
        name: 'CityCompany',
        component: () =>
          import(
            /* webpackChunkName: "cityCompany" */ '@/views/root/cityCompany'
          ),
      },
      {
        path: 'newAsync',
        name: 'NewAsync',
        component: () =>
          import(/* webpackChunkName: "newAsync" */ '@/views/root/newAsync'),
      },
      {
        path: 'myAbout',
        name: 'MyAbout',
        component: () =>
          import(/* webpackChunkName: "myAbout" */ '@/views/root/myAbout'),
      },
      {
        path: 'storeEnter',
        name: 'StoreEnter',
        component: () =>
          import(
            /* webpackChunkName: "storeEnter" */ '@/views/root/storeEnter'
          ),
      },
      {
        path: 'newsDetaile',
        name: 'NewsDetaile',
        component: () =>
          import(
            /* webpackChunkName: "storeEnter" */ '@/views/root/newsDetaile'
          ),
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

export default router;
